import axios from 'axios';
import * as Sentry from "@sentry/react";

interface onDownloadContractDoneFileProps {
  contract: { contractIdx?: number };
}

export const onDownloadContractDoneFile = async ({
  contract,
}: onDownloadContractDoneFileProps) => {
  const token = sessionStorage.getItem('token');
  const targetContractIdx = contract.contractIdx;

  try {
    if (res.data.ErrorCode === 0) {
      const response = await axios.get(
        `${process.env.COMMON_URL}/cost/cs10040/contractdownload/${targetContractIdx}?type=S`,
        {
          headers: {
            tokenId: token,
          },
          responseType: 'blob',
        }
      );

      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));

      const $a = document.createElement('a');
      $a.href = downloadUrl;
      $a.download = targetContractIdx!.toString();
      document.body.appendChild($a);
      $a.click();
      document.body.removeChild($a);
      window.URL.revokeObjectURL(downloadUrl);
    } else {
      Sentry.captureMessage(`Server Error : CS10-040 : ErrorCode: ${res.data.ErrorCode}\n\nErrorMsg: ${res.data.ErrorMsg}`);
      alert(`정상적으로 처리되지 않았습니다.\n\nErrorCode: ${res.data.ErrorCode}\n\nErrorMsg: ${res.data.ErrorMsg}`);
    }

  } catch (e) {
     Sentry.captureException(e);
    console.error('파일 다운로드 중 에러가 발생했습니다:', e);
  }
};
